import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import NotificacionesEnAndroid from './NotificacionesEnAndroid';
import { App as CapacitorApp } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import * as firebaseConfig from './firebase-config';
import { LocalNotifications } from '@capacitor/local-notifications';
import { registerPlugin } from '@capacitor/core';
import { Badge } from '@capawesome/capacitor-badge';
import { PushNotifications } from '@capacitor/push-notifications';
import Cargando from './Cargando';
import Mensaje from './Mensaje';

const ManejoNotificacionesEnAndroid = () => {
  const { requestPushPermission, checkNotification } = NotificacionesEnAndroid();
  const navigate = useNavigate();
  const { SetMensaje } = Mensaje();
  const { StartCargando, StopCargando } = Cargando();

  useEffect(() => {
    let listener;

    CapacitorApp.addListener('appUrlOpen', ({ url }) => {
      try {
        const parsedUrl = new URL(url);
        const fullPath = parsedUrl.pathname + parsedUrl.search;
        console.log('Redireccionando a:', fullPath);
        // window.location.href = fullPath;
        navigate(fullPath)
      } catch (e) {
        console.error('Error parsing URL:', e);
      }
    }).then((handle) => {
      listener = handle;
    });

    // return () => {
    //   if (listener) {
    //     listener.remove();
    // //   }
    // };
  }, []);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const next = urlParams.get('next');
    if (next) {
      urlParams.delete('next');
      const remainingParams = urlParams.toString();
      const fullPath = next + (remainingParams ? `?${remainingParams}` : '');
      navigate(fullPath);
    }
  }, []);

  // Suscribir al canal de notificaciones de Capacitor
  const subscribeToPushNotifications = async () => {
    // Evento cuando se registra el dispositivo y se obtiene el token de registro
    await PushNotifications.addListener('registration', async (token) => {
      // console.log('Token de registro de notificación:', token.value);
      await firebaseConfig.savetoken(token.value);
    });

    // Evento cuando hay un error en el registro de notificaciones
    await PushNotifications.addListener('registrationError', (error) => {
      StopCargando();
      SetMensaje("Error", "Error al activar notificacion", 3000);
      console.error('Error de registro de notificaciónnn:', error);
    });

    // Evento cuando se recibe una notificación
    await PushNotifications.addListener('pushNotificationReceived', async (notification) => {
      console.log('push notification received: ' + JSON.stringify(notification));
      SetMensaje("Informacion", notification.data.body, 3000);
      const notificationList = await PushNotifications.removeAllDeliveredNotifications();
      // console.log('delivered notifications', JSON.stringify(notificationList));
      if (window.updatenoti) {
        var actualizar = false;
        if (notification.data.actualizar) {
          if (notification.data.actualizar == "SI") {
            actualizar = true;
          }
        }
        window.updatenoti(actualizar);
      }
    });

    // Evento cuando el usuario realiza una acción sobre una notificación
    await PushNotifications.addListener('pushNotificationActionPerformed', (notification) => {
      console.log('Push action performed: ' + JSON.stringify(notification));
      console.log('url' + notification.notification.data.link_url);
      // Aquí puedes redirigir al usuario a una URL o a una pantalla específica dentro de la app
      if (notification.notification.data.link_url) {
        const url = new URL(notification.notification.data.link_url);
        const path = url.pathname + url.search;
        // window.location.href = path; // Redirige al usuario a la URL de la notificación
        if (path.includes("/client/MisTarjetas/")) {
          const parts = path.split("/");
          const numeroFinal = parts[parts.length - 1];
          const tarjetas = JSON.parse(localStorage.getItem("tarjeta"));
          const index = tarjetas.findIndex(t => t.NumeroTarjeta === numeroFinal);

          if (index === -1) {
            // console.log("❌ No se encontró la tarjeta con ese número.");
          } else {
            // console.log("✅ Tarjeta encontrada en el índice:", index);
            sessionStorage.setItem("TarjetaCargada_indice", index.toString());
          }
          // handleButtonRedireccionarTarjeta(numeroFinal);
          navigate('/client/MisTarjetas');
        } else {
          navigate(path);
        }
      }
    });

    const { display } = await Badge.checkPermissions();
    if (display !== 'granted') {
      await Badge.requestPermissions();
    }
  };

  useEffect(() => {

    if (Capacitor.isNativePlatform()) {
      // await checkNotification();
      subscribeToPushNotifications();
    }
  }, []);
  return (
    <div>
    </div>
  );
};


export default ManejoNotificacionesEnAndroid;
